$(document).ready(function(){
	var tabs = [];
	var viewButtons = [];

	$(".tabs .tab").map(function(i, e){
		tabs.push($(e));
		$(e).attr("data-index", i);
	});

	$(".view-type span").map(function(i, e){
		viewButtons.push($(e));
		$(e).attr("data-index", i);
	});

	$(tabs[0]).addClass("active");
	$(viewButtons[0]).addClass("active");

	$(".view-type span").on("click", function(){
		var index = $(this).data("index");
		$(".tabs .tab").removeClass("active");
		$(".view-type span").removeClass("active");
		$(tabs[index]).addClass("active");
		$(viewButtons[index]).addClass("active");
		google.maps.event.trigger(map, 'resize');
		initMap();
	});

	function sort(){

		$(".sort-dropdown-opener").on("click", function(){
			$(this).find(".sort-dropdown").toggleClass("active");
		});

		$(document).on("click", function(e){
			if($(e.target).closest(".sort-dropdown-opener").length == 0) {
				$(".sort-dropdown").removeClass("active");
			}
		});
	}

	function dropdownInputs(){
		$(".dropdown input[type=number]").on("click", function(){
			$(this).parent().find(".range").addClass("active");
		});

		$(document).on("click", function(e) {
			if($(e.target).closest(".dropdown input[type=number]#id_pf").length == 0 && $(e.target).closest(".range").length == 0) {
				$($(".range")[0]).removeClass("active");
			}
			if($(e.target).closest(".dropdown input[type=number]#id_pt").length == 0 && $(e.target).closest(".range").length == 0) {
				$($(".range")[1]).removeClass("active");
			}
		});

		$(".range input").each(function(){
			$(this).val($(this).parent().parent().find("input[type=number]").val());

			var min = $(this).attr("min");
			var max = $(this).attr("max");

			$(this).parent().find(".min").html(min);
			$(this).parent().find(".max").html(max);
		});

		$(".range input").on("change input", function(){
			var amount = $(this).val();
			$(this).parent().parent().find("input[type=number]").val(amount);
		});

		$(".dropdown input[type=number]").on("change input", function(){
			var amount = $(this).val();
			$(this).parent().find(".range input").val(amount);
		});
	}

	sort();
	dropdownInputs();

});


// WEBPACK FOOTER //
// src/js/bundle/offers.js